<template>
  <section class="page-header">
    <div class="page-header__hgroup">
      <h1 class="page-header__title">Acupuncture Laflamme</h1>
    </div>

    <div class="layout-section__hgroup">
      <h2 class="layout-section__heading">Mandate</h2>

      <ul class="layout-section__list">
        <li>Establish a new brand image to better reflect his target audience</li>
        <li>Create new buisiness cards</li>
        <li>Create social media design templates</li>
        <li>Design a new website</li>
        <li>Implement the new website as an SPA using VueJS and Sass</li>
        <li>Connect the website frontend to Prismic CMS for editorial autonomy</li>
      </ul>
    </div>

    <div class="layout-section__hgroup">
      <h2 class="layout-section__heading">Tools</h2>

      <ul class="layout-section__list">
        <li>Adobe XD, Illustrator</li>
        <li>HTML, SCSS, Vue JS</li>
        <li>Prismic (CMS)</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LaflammeHeader'
}
</script>
